import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css']
})
export class LoginFormComponent implements OnInit {
  loginForm: FormGroup;

  @Input()
  hasError = false;

  @Input()
  isLoading = false;

  @Output()
  login = new EventEmitter();

  constructor(
    fb: FormBuilder
  ) {
    this.loginForm = fb.group({
      login: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  ngOnInit() {}

  onLogin() {
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    const values = this.loginForm.value;
    this.login.next(values);
  }
}
